import { getUrlParamsFromCriteria } from '@/hooks/useQueryCriteria';
import { ClearOutlined, SearchOutlined } from '@ant-design/icons/lib';
import { Button, Col, Row } from 'antd';
import { FC, ReactNode, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { FieldRender, ItemFieldType } from '../FieldRender';
import { Form, FormItem, useForm } from '../FormCommon';

export const filterFields: ItemFieldType = {
  keyword: {
    name: 'keyword',
    component: 'input',
    propsComponent: {
      placeholder: 'name|code|alias',
    },
  },
  published: {
    name: 'published',
    component: 'select',
    propsComponent: {
      allowClear: true,
      placeholder: 'status',
      options: [
        { key: 'published', label: 'published', value: 'true' },
        { key: 'unpublished', label: 'unpublished', value: 'false' },
      ],
    },
  },
};

type Props = {
  onSubmit: (values: any) => void;
  customFields?: ItemFieldType;
  extendFields?: ItemFieldType;
  extendBtn?: ReactNode;
  criteria?: any;
};

const FilterForm: FC<Props> = (props: Props) => {
  const { onSubmit, extendFields, extendBtn, customFields, criteria } = props;
  const location: any = useLocation();
  const [form] = useForm();

  const handleOnFinish = (values) => {
    if (onSubmit) {
      onSubmit(values);
    } else {
      console.warn('please add handle submit', values);
    }
  };

  const fields = useMemo(() => {
    if (customFields) {
      return {
        ...customFields,
      };
    }
    if (!extendFields) {
      return {
        ...filterFields,
      };
    }
    return {
      ...filterFields,
      ...extendFields,
    };
  }, [extendFields]);

  const getInitialValues = (paramsSearch) => {
    if (!paramsSearch) return;
    const {
      keyword,
      published,
      floorNumber,
      type,
      types,
      status,
      page,
      size,
      sort,
      displayExternalTypes,
      createType,
    } = paramsSearch;

    return {
      page,
      size,
      sort,
      keyword: keyword || '',
      published: published || null,
      floorNumber: floorNumber || null,
      type: type || null,
      types: types ? types.split(',') : [],
      status: status ? status.split(',') : [],
      displayExternalTypes: displayExternalTypes ? displayExternalTypes.split(',') : [],
      createType: createType || null,
    };
  };

  const urlParams = getUrlParamsFromCriteria(criteria, { ...location.query });

  useEffect(() => {
    form.setFieldsValue(getInitialValues(urlParams));
  }, [urlParams]);

  return (
    <Form name="filterForm" form={form} onFinish={handleOnFinish}>
      <Row gutter={24}>
        {Object.keys(fields).map((key) => {
          const val = fields[key];
          return (
            <Col key={key} span={8}>
              <FieldRender {...val} />
            </Col>
          );
        })}
      </Row>
      <Row>
        <Col span={24} style={{ textAlign: 'right' }}>
          <FormItem>
            {extendBtn}

            <Button type="primary" htmlType="submit" icon={<SearchOutlined />}>
              Search
            </Button>
            <Button
              style={{ margin: '0 8px' }}
              type="default"
              onClick={() => form.resetFields()}
              icon={<ClearOutlined />}
            >
              Clear
            </Button>
          </FormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default FilterForm;
